module.exports = __webpack_public_path__ + "img/kangshuai.46e7ded9.png";